import { Flex, Image, Text } from "@aws-amplify/ui-react";
import { Grid, useMediaQuery } from "@mui/material";
import { images } from "constants/index";
import { motion } from "framer-motion";

export const AboutSC = () => {
  const matches = useMediaQuery("(min-width:800px)");
  const hMatches = useMediaQuery("(min-height:490px)");

  return (
    <Grid
      container
      position="relative"
      display="flex"
      width="100%"
      id="about"
      // backgroundColor="red"
      height="100vh"
      direction="column"
      wrap="nowrap"
      // marginTop="20px"
      paddingTop="80px"
      paddingBottom="20px"
      sx={{
        overflowX: "hidden",
        overflowY: "hidden",
      }}
      // overflow="hidden"

      // backgroundColor="blue"
    >
      <Grid
        position="absolute"
        display="flex"
        width="100%"
        height="100%"
        zIndex="45"
        marginTop="-30px"
        justifyContent="center"
        alignItems="center"

        // backgroundColor="teal"
      >
        <motion.div
          // className='

          //  bg-teal-500'
          initial={{
            opacity: 0.3,
            scale: 0.2,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          transition={{
            duration: 3,
            type: "spring",
          }}
        >
          <Image
            src="/flowerthing.png"
            alt=""
            // backgroundColor="red"

            width={matches ? "800px" : "600px"}
            display={hMatches ? "block" : "none"}
            height="auto"
            objectFit="cover"
            position="relative"
          />
        </motion.div>
      </Grid>

      <section className="flex flex-col font-[5px] w-[100%] pt-5 pb-5  pl-8 pr-8  ">
        <motion.section
          initial={{
            opacity: 0.3,
            scale: 0.8,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          transition={{ duration: 2 }}
        >
          <Text
            className="relative sm: text-3xl md:text-[63px]"
            //  width="100%"

            fontSize={matches ? "35px" : "25px"}
            color="white"
            fontFamily="lolita-one"
          >
            <div className=" font-lolita-one">OUR MISSION</div>
          </Text>
        </motion.section>

        <div className="  sm:text-xl text-white sm:pt-0 md:text-[22px] md:pt-0 font-lolita-one">
          We support well rounded leaders who prioritize health, community,
          humanity and personal excellence.
        </div>
      </section>

      <Flex
        position="relative"
        //  display="block"
        width="100%"
        height="100%"
        //  backgroundColor="#0C8645"
        // backgroundColor="pink"
        justifyContent="flex-end"
        alignItems="end"
      >
        <Image
          onClick={() => {
            const offset = 60;
            const upcomingEvent = document.getElementById("ehr");

            if (upcomingEvent) {
              const top =
                upcomingEvent.getBoundingClientRect().top +
                window.pageYOffset -
                offset;
              window.scrollTo({ top, behavior: "smooth" });
            }

            // upcomingEvent?.scrollIntoView({ behavior: "smooth" });
          }}
          style={{
            zIndex: 9999,
          }}
          paddingBottom={20}
          width={200}
          alt=""
          src={images.downarrow}
        />
        <section className="flex flex-col  w-[60vw] pt-5 pb-5  pl-8 pr-8 font-lolita-one">
          <motion.section
            initial={{
              opacity: 0.3,
              scale: 0.8,
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
            }}
            transition={{ duration: 2 }}
          >
            <Text
              className="relative sm: text-3xl md:text-[63px]"
              //  width="100%"

              fontSize={matches ? "35px" : "25px"}
              color="white"
            >
              OUR VISION
            </Text>
          </motion.section>

          <div className="  sm:text-xl text-white sm:pt-0 md:text-[22px] md:pt-0 ">
            To normalize the act of pouring into your neighbor to create a
            legacy one can be proud of.
          </div>
        </section>
      </Flex>
    </Grid>
  );
};
